export default __webpack_public_path__ + "static/media/msg_info.27b52a68.svg";